export default __webpack_public_path__ + "static/media/repeat-arrows.079b86ca.svg";